import { FormControl, FormHelperText, IconButton, InputAdornment, InputLabel, ListSubheader, MenuItem, Select } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useState } from 'react';
import { useController, UseControllerProps } from 'react-hook-form';
import { IDropDownOptions } from './AppSelectList';
import colors from '../../../../assets/theme/base/colors';

export interface IDropDownOptionsGroup {
    group: string;
    items: IDropDownOptions[];
}

interface IProps extends UseControllerProps {
    label: string;
    groups: IDropDownOptionsGroup[];
    size?: 'small' | 'medium';
    disabled?: boolean;
    onChange?: (value: any) => void;
}

const subheaderSx = {
    fontSize: '0.75rem',
    fontWeight: 600,
    color: colors.ui.tertiaryText,
    textTransform: 'uppercase' as const,
    letterSpacing: '0.08em',
};

const AppSelectListWithGroups = (props: IProps) => {
    const { fieldState, field } = useController({ ...props, defaultValue: props.defaultValue ?? '' });
    const [open, setOpen] = useState<boolean>(false);

    return (
        <FormControl fullWidth error={!!fieldState.error}>
            <InputLabel disabled={props.disabled}>{props.label}</InputLabel>
            <Select
                open={open}
                value={field.value ?? ''}
                label={props.label}
                onChange={(event) => {
                    field.onChange(event);
                    if (props.onChange && event.target.value != null) {
                        props.onChange(event.target.value);
                    }
                }}
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
                sx={{ padding: '0.75rem 0 !important', fontSize: '0.875rem' }}
                size={props.size}
                disabled={props.disabled}
                renderValue={(selected) => {
                    for (const group of props.groups) {
                        const found = group.items.find(item => item.id === selected);
                        if (found) return found.value;
                    }
                    return '';
                }}
                endAdornment={
                    field.value != null && field.value !== '' && (
                        <InputAdornment position="end">
                            <IconButton
                                size="small"
                                onClick={() => field.onChange(null)}
                                disabled={props.disabled}
                            >
                                <ClearIcon />
                            </IconButton>
                            <IconButton
                                style={{ paddingLeft: '0px' }}
                                onClick={() => setOpen(true)}
                                disabled={props.disabled}
                            >
                                <ArrowDropDownIcon />
                            </IconButton>
                        </InputAdornment>
                    )
                }
            >
                {props.groups.map((group, index) => [
                    <ListSubheader key={`header-${group.group}`} sx={{ ...subheaderSx, ...(index > 0 ? { borderTop: `1px solid ${colors.ui.border}` } : {}) }}>
                        {group.group}
                    </ListSubheader>,
                    ...group.items.map(item => (
                        <MenuItem key={item.id} value={item.id} sx={{ fontSize: '0.875rem' }}>
                            {item.value}
                        </MenuItem>
                    )),
                ])}
            </Select>
            <FormHelperText>{fieldState.error?.message}</FormHelperText>
        </FormControl>
    );
};

export default AppSelectListWithGroups;
